<template>
    <div>
        <div v-for="(item,index) in dataList" :key="index" class="card-li">
            <a :href="'./news_details.html?active='+active+'&id='+item.id">
                <div class="card-li-img" v-if="type=='2'">
                    <img :src="item.contentImg" alt="" />
                </div>
                <div class="card-li-left" :style="{'width':type!='2'?'100%':''}">
                    <h6>
                        <img src="@/assets/index/index_icon1.png" alt="" v-if="active == 2">
                        <img src="@/assets/index/index_icon22.png" alt="" v-if="active == 3">
                        <span>{{item.contentTitle}}</span>
                    </h6>
                    <p class="card-li-left-p">{{item.contentDescription}}</p>
                    <div
                        :class="{'card-li-left-info':'card-li-left-info','card-li-left-info2':type!='2'?'card-li-left-info2':''}">
                        <p>来源：<span>{{item.contentSource}}</span></p>
                        <p>发布时间：<span>{{item.modifyTime | datefilter}}</span></p>
                        <p>浏览量：<span>{{item.contentHit}}</span></p>
                        <!-- <div>
                            <span>{{item.modifyTime | datefilter}}</span>
                            <span><i class="el-icon-view"></i>&nbsp;{{item.contentHit}}</span>
                        </div> -->
                    </div>
                </div>
            </a>
        </div>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="from.pageNo"
            :page-sizes="[10, 20, 50,100]" :page-size="from.pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="total" style="text-align: right;padding: 22px 0 42px 0;" v-show="dataList.length!='0'">
        </el-pagination>
    </div>
</template>
<script>
/**
 * Component newsCardList 页脚组件
 	@author fanjun
  @props data（必选属性前面带＊，非必选项目请备注默认值）
    －*type : String,'1'(默认) - 1、政策法规 2、行业新闻  3、通知公告
    active : String,'2'(默认) - 2、政策法规 3、行业新闻  4、通知公告
	@example
	<footer/>
**/
import { Pagination } from "element-ui";
// import "./index.scss";
export default {
    name: "newsCardList",
    components: {
        [Pagination.name]: Pagination,
    },
    props: {
        type: {
            type: String,
            required: true,
            default: "1",
        },
        active: {
            type: String,
            required: false,
            default: "2",
        },
    },
    data() {
        return {
            from: {
                postType: "",
                pageNo: 1,
                pageSize: 10,
            },
            dataList: [],
            total: 50,
            checkForm: {
                status: "2", //已发布
                contentCategoryId: "", //152-政策法规、153-行业新闻、154-通知公告
                companId: 0,
                indexFlag: "Y",
                pageNum: 1,
                pageSize: 10,
            },
        };
    },
    filters: {
        datefilter: function (val) {
            var date = new Date(val);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            var d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + m + "-" + d;
        },
    },
    created() {
        console.log(this.type, '---------------');
        if (this.type == "1") {
            this.checkForm.contentCategoryId = "152";
        } else if (this.type == "2") {
            this.checkForm.contentCategoryId = "153";
        } else if (this.type == "3") {
            this.checkForm.contentCategoryId = "154";
        }
        this.getData(); //获取数据
    },
    methods: {
        getData: function () {
            this.$api
                .queryContentList(this.checkForm)
                .then((res) => {
                    console.log(res);
                    if (res.data.resultCode == 200) {
                        this.dataList = res.data.result;
                        this.total = res.data.total;
                    } else {
                        this.$message.error({ title: res.data.resultDesc });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        handleCurrentChange: function (pageNum) {
            // 改变页码
            this.checkForm.pageNum = pageNum;
            this.getData();
        },
        handleSizeChange: function (val) {
            this.checkForm.pageSize = val;
            this.checkForm.pageNum = 1;
            this.getData();
        },
    },
};
</script>
<style scoped lang="scss">
    .card-li{
    width: 100%;
    padding: 32px;
    box-sizing:border-box ;
    overflow: hidden;
    background: #F8F8F8;
    margin-bottom: 28px;
    position: relative;
    background-image: url('~@/assets/index/li_bg.png');
    background-repeat: repeat;
    background-position: center center;
    background-size: cover;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
    .card-li-img{
        width: 285px;
        height: 188px;
        float:left;
        overflow: hidden;
        img{
            width: 285px;
            height: 188px;
            transition: all 0.5s; 
            &:hover{  
                transform: scale(1.1);  
            }  
        }
    }
    .card-li-left{
        width: 833px;
        float: right;
        h6{
            display: flex;
            flex-direction: row;
            font-size: 20px;
            color: #09173E;
            font-weight:500;
            line-height: 20px;
            margin-bottom: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            img{
                width: 20px;
                height: 20px;
                margin-right: 10px;
            }
        }
        .card-li-left-p{
            font-size: 14px;
            line-height: 24px;
            min-height: 48px;
            color: #09173E;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
            margin-bottom: 30px;
        }
    }
    .card-li-left-info2{
        width: 100% !important;
        box-sizing: border-box !important;
        padding: 0 32px !important;
        left: 0 !important;
    }
    .card-li-left-info{
        width: 833px;
        position: absolute;
        bottom: 32px;
        right: 32px;
        p{
            width: 260px;
            display: inline-block;
            font-weight: 350;
            font-size: 14px;
            line-height: 16px;
            color: #9C9C9C;
        }
        div{
            float: right;
            font-size: 16px;
            line-height: 22px;
            color: #bbb;
            span:last-child{
                margin-left:20px ;
            }
        }
    }
}
</style>

